export const enum DatadogEvent {
    LibrarySelected = 'Libs-Selected',
    LibThumbColor = 'Libs-ThumbnailColor',
    LibThumbImage = 'Libs-ThumbnailImage',
    LibBulkDelete = 'Bulk-Delete',
    LibChangeCategory = 'Libs-ChangeCategory',
    ClipboardPaste = 'Paste from Clipboard',
    RightClickMenuOpen = 'Opened Right Click Menu',
    ResetPreview = 'Reset Whole Preview',
    ResetPreviewElements = 'Reset Design Element Only'
}

export const fireDatadogLog = (logType: DatadogEvent) => {
    const datadogRum = window.DD_RUM;
    if (!datadogRum) return;
    datadogRum.addAction(logType);
};
